import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=4a01207c&scoped=true&"
var script = {}
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=4a01207c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01207c",
  null
  
)

export default component.exports